import { AddImage, Image, ImageNode } from '@components/add-image/add-image';
import { IconImage } from '@components/icons/image';
import { getScopedTranslate } from '@locale/translate';

import { FieldDropzone } from './field-dropzone';

import { conditionsTab } from '../conditions-tab';
import { useFormBuilderContext } from '../context';
import { FieldEdit } from '../field-edit';
import { FieldConfig } from '../field-registry';
import { FieldSidebarLabel } from '../fields-sidebar';

export { Image };

type Config = FieldConfig<'image'>;

const Display: Config['Display'] = ({ field }) => {
  return <ImageNode url={field.url} />;
};

const FormBuilderImage: Config['Component'] = ({ field, dragHandle }) => {
  const {
    store: { onImageSave, actions: formActions },
  } = useFormBuilderContext();

  const handleOnFileSelected = async (image: File, setProgress?: (progress: number) => void) => {
    const data = new FormData();
    data.append(field.id, image);
    let imageId;
    try {
      formActions.startSaving();
      imageId = await onImageSave?.({ data, setProgress });
    } finally {
      formActions.stopSaving();
    }
    if (!imageId) return;
    formActions.createChangeHandler(field, 'url')(URL.createObjectURL(image));
    formActions.createChangeHandler(field, 'imageId')(imageId);
  };

  return (
    <FieldDropzone field={field}>
      <FieldEdit
        field={field}
        dragHandle={dragHandle}
        display={<Display field={field} />}
        edit={
          <AddImage
            url={field.url}
            onChange={handleOnFileSelected}
            handleUpload={handleOnFileSelected}
          />
        }
      />
    </FieldDropzone>
  );
};

const { t } = getScopedTranslate({
  en: {
    title: 'Image',
  },
});

export const imageConfig: Config = {
  kind: 'image',
  title: t('title'),
  group: 'content',
  Icon: IconImage,
  Component: FormBuilderImage,
  Display,
  TreeDisplay: () => <FieldSidebarLabel label={t('title')} />,
  propertiesTabs: [conditionsTab],
};
